import { render, staticRenderFns } from "./LangChart.vue?vue&type=template&id=38f1548d&lang=pug&"
import script from "./LangChart.vue?vue&type=script&lang=js&"
export * from "./LangChart.vue?vue&type=script&lang=js&"
import style0 from "./LangChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports